module.exports = __webpack_public_path__ + "img/activity_overage1.bb29fa9e.png";